import ChatRoom from './chat-room'

export default ChatRoom
